<div class="page-container report-page" [class.loading]="isLoading">
    <app-header title="reporting.reports.assetReport.title" [back]="true" class="report-header">
        <div class="buttons">
            <ui-button type="primary" style="float: right" [matMenu]="exportMenu">
                {{ 'export' | translate }} <mat-icon svgIcon="chevronDown"></mat-icon>
            </ui-button>
            <mat-menu #exportMenu="matMenu">
                <button mat-menu-item (click)="onExport('csv')">{{ 'export-as-csv' | translate }}</button>
                <button mat-menu-item (click)="onExport('xlxs')">{{ 'export-as-xlsx' | translate }}</button>
            </mat-menu>
        </div>
    </app-header>

    <div *ngIf="report && report.data.sheets && report.data.sheets.length; else emptyState" class="report-body">
        <app-report-table [report]="report" emptyText="reporting.reports.thereAreNoAssetsToReportOn"></app-report-table>
    </div>

    <ng-template #emptyState>
        <ui-card>
            <app-empty-state label="reporting.reports.thereAreNoAssetsToReportOn"></app-empty-state>
        </ui-card>
    </ng-template>
</div>
